import * as React from "react";
import {
  Avatar,
  TitleBar,
  TextInput,
  MessageList,
  AgentBar,
  Title,
  Subtitle,
  MessageGroup,
  TextComposer,
  Row,
  Fill,
  Fit,
  IconButton,
  SendButton,
  CloseIcon,
  Column,
  RateGoodIcon,
  RateBadIcon,
  MenuVerticalIcon
} from "@livechat/ui-kit";
import ArrowDownIcon from "./ArrowDownIcon";
import { getTranslatedMessage, language } from "../utils/translations";
import EmailIcon from "./EmailIcon";
import { Menu } from "./Menu";
import { MenuItem } from "./MenuItem";
import { CardCarousal } from "./CardCarousal";
import { ComposedMessage } from "./ComposedMessage";
import { SendTranscriptDialog } from "./SendTranscriptDialog";
import PreChatForm from "./PreChatForm";
import chatScreens from "../constants/chatScreens";
import PostChatForm from "./PostChatForm";

const getAvatarForUser = (userId, users) => {
  const foundUser = users[userId];
  if (foundUser && foundUser.avatarUrl) {
    return foundUser.avatarUrl;
  }
  return null;
};
const getUserName = users => (id, isClient) => {
  const user = users[id] || { name: "" };
  return isClient ? getTranslatedMessage("you") : user.name;
};

const parseUrl = url =>
  url && "https://" + url.replace(/^(http(s)?\:\/\/)/, "").replace(/^\/\//, "");

const styles = {
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    background: "white",
    position: "relative",
    direction: language === "en" ? "ltr" : "rtl"
  },
  titleBar: {
    background: "#a9cf4d"
  },
  hr: {
    borderBottom: "1px solid rgb(233,238,244)",
    height: 1,
    width: "100%"
  },
  messageGroup: {
    maxWidth: 320,
    "&>div": {
      overflow: "visible"
    }
  },
  sender: {
    fontSize: 12,
    color: "#93a1af",
    marginTop: -16
  },
  poweredBy: {
    textAlign: "center",
    fontSize: ".6em",
    padding: ".4em",
    background: "#fff",
    color: "#888",
    position: "absolute",
    bottom: 0
  },
  innerContainer: {
    display: "flex",
    flexDirection: "column",
    height: "calc(100% - 80px)"
  },
  messageListContainer: {
    flexGrow: 1,
    minHeight: 0,
    direction: "ltr",
    marginBottom: 16,
    overflowY: "auto",
    maxHeight: "calc(100% - 125px)"
  },
  queue: {
    textAlign: "center",
    margin: 50
  },
  textComposer: {
    zIndex: 1000
  }
};

class Maximized extends React.Component {
  menuRef = null;
  menuButtonRef = null;
  messageListEndRef = null;
  sendTranscriptRef = null;

  state = {
    isMenuOpen: false,
    email: "",
    isSendTranscriptOpen: false
  };
  componentDidMount() {
    document.addEventListener("click", this.onClick);
  }
  componentWillUnmount() {
    document.removeEventListener("click", this.onClick);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.events.length < this.props.events.length) {
      this.messageListEndRef.scrollIntoView({block: "end"});
      setTimeout(() => {
        this.messageListEndRef.scrollIntoView({block: "end"});
      }, 10)
    }
  }
  onClick = event => {
    if (
      event.target &&
      this.menuRef &&
      !this.menuRef.contains(event.target) &&
      !this.menuButtonRef.contains(event.target)
    ) {
      this.closeMenu();
    }
    if (
      event.target &&
      this.state.isSendTranscriptOpen &&
      !this.sendTranscriptRef.contains(event.target)
    ) {
      this.closeSendTranscript();
    }
  };
  openMenu = () => {
    this.setState({
      isMenuOpen: true
    });
  };
  closeMenu = () => {
    this.setState({
      isMenuOpen: false
    });
  };
  openSendTranscript = () => {
    this.closeMenu();
    setTimeout(() => {
      this.setState({
        isSendTranscriptOpen: true
      });
    }, 10);
  };
  closeSendTranscript = () => {
    this.setState({
      isSendTranscriptOpen: false
    });
  };
  onSendTranscript = email => {
    this.closeSendTranscript();
    this.props.sendTranscript(email);
  };
  onCloseChat = () => {
    this.closeMenu();
    this.props.closeChat();
  };
  onSubmitPreForm = payload => {
    this.props.savePreForm(payload);
    this.props.sendMessage("Get Started", "Get Started");
  };
  render() {
    const {
      chatState,
      events,
      onMessageSend,
      users,
      ownId,
      currentAgent,
      minimize,
      sendMessage,
      rateGood,
      rateBad,
      rate,
      isChatting,
      savePreForm,
      sendPostForm,
      activeScreen,
      numberInQueue
    } = this.props;
    const { isMenuOpen, isSendTranscriptOpen } = this.state;
    const getUserNameById = getUserName(users);
    return (
      <div style={styles.root}>
        <TitleBar
          style={styles.titleBar}
          rightIcons={[
            <IconButton key="close" onClick={minimize}>
              <ArrowDownIcon />
            </IconButton>
          ]}
          leftIcons={[
            <div ref={ref => (this.menuButtonRef = ref)}>
              <IconButton key="menu" onClick={this.openMenu}>
                <MenuVerticalIcon />
              </IconButton>
            </div>
          ]}
          title={getTranslatedMessage("welcome")}
        />
        {isMenuOpen && (
          <div ref={ref => (this.menuRef = ref)}>
            <Menu>
              <MenuItem
                msg="send transcript"
                disabled={!isChatting}
                Icon={EmailIcon}
                onClick={this.openSendTranscript}
              />
              <div style={styles.hr} />
              <MenuItem
                msg="close"
                disabled={!isChatting}
                Icon={CloseIcon}
                onClick={this.onCloseChat}
              />
            </Menu>
          </div>
        )}
        {isSendTranscriptOpen && (
          <div ref={ref => (this.sendTranscriptRef = ref)}>
            <SendTranscriptDialog onSend={this.onSendTranscript} />
          </div>
        )}
        {activeScreen === chatScreens.PRECHAT && (
          <PreChatForm onSubmit={this.onSubmitPreForm} />
        )}
        {activeScreen === chatScreens.QUEUE && (
          <div style={styles.queue}>
            <p>{`${getTranslatedMessage(
              "queue1"
            )}${numberInQueue}${getTranslatedMessage("queue2")}`}</p>
            <p>{`${getTranslatedMessage("queue3")}`}</p>
          </div>
        )}
        {activeScreen === chatScreens.POSTCHAT && (
          <PostChatForm onSubmit={sendPostForm} />
        )}
        {activeScreen === chatScreens.CHAT && (
          <div style={styles.innerContainer}>
            {currentAgent && (
              <AgentBar>
                <Row flexFill>
                  <Column>
                    <Avatar imgUrl={parseUrl(currentAgent.avatarUrl)} />
                  </Column>
                  <Column flexFill style={{ margin: "0 10px" }}>
                    <Title>{currentAgent.name}</Title>
                  </Column>
                  <Column flexFit>
                    {chatState === "CHATTING" && (
                      <Row>
                        <IconButton onClick={rateGood}>
                          <RateGoodIcon
                            style={{
                              opacity: rate === "good" ? "1" : "0.5"
                            }}
                          />
                        </IconButton>
                        <IconButton onClick={rateBad}>
                          <RateBadIcon
                            style={{
                              opacity: rate === "bad" ? "1" : "0.5"
                            }}
                          />
                        </IconButton>
                      </Row>
                    )}
                  </Column>
                </Row>
              </AgentBar>
            )}
            <div style={styles.messageListContainer} >
              <MessageList active containScrollInSubtree style={{WebkitOverflowScrolling: 'touch', overflowY: "unset", height: "auto"}}>
                {events.map((messageGroup, index) => {
                  if (!messageGroup[0]) {
                    return null;
                  }
                  const firstMessage =
                    messageGroup[0] && (messageGroup[0][0] || messageGroup[0]);
                  const { own, authorId, parsedDate } = firstMessage;
                  const authorName = getUserNameById(authorId, own);
                  const avatar = parseUrl(getAvatarForUser(authorId, users));
                  return (
                    <div
                      style={{
                        visibility: isSendTranscriptOpen ? "hidden" : "visible"
                      }}
                    >
                      <Row reverse={own}>
                        {avatar && (
                          <Avatar imgUrl={avatar} style={{ marginTop: 4 }} />
                        )}
                        <MessageGroup
                          key={index}
                          style={styles.messageGroup}
                          onlyFirstWithMeta
                        >
                          {messageGroup.map(message =>
                            Array.isArray(message) ? (
                              <CardCarousal
                                cards={message}
                                ownId={ownId}
                                sendMessage={sendMessage}
                              />
                            ) : (
                              <ComposedMessage
                                message={message}
                                ownId={ownId}
                                sendMessage={sendMessage}
                                isLastMsg={index === events.length - 1}
                              />
                            )
                          )}
                        </MessageGroup>
                      </Row>
                      <Row reverse={own} style={styles.sender}>
                        {`${authorName} - ${parsedDate}`}
                      </Row>
                    </div>
                  );
                })}
                
              </MessageList>
              <div style={{width: 1, height: 1}} ref={ref => (this.messageListEndRef = ref)} />
            </div>
            <TextComposer onSend={onMessageSend} style={styles.textComposer}>
              <Row align="center">
                <Fill>
                  <TextInput
                    id="chatInput"
                    on
                    placeholder={getTranslatedMessage("write message")}
                  />
                </Fill>
                <Fit>
                  <SendButton
                    id="chatSendMsg"
                    style={{
                      transform: language === "ar" && "rotateY(180deg)"
                    }}
                  />
                </Fit>
              </Row>
            </TextComposer>
          </div>
        )}

        <div style={styles.poweredBy}>{"Powered by Labiba.ai"}</div>
      </div>
    );
  }
}

export default Maximized;



// WEBPACK FOOTER //
// ./src/components/Maximized.js